<div class="core-container" fxLayout="column" fxLayoutAlign="center center">
  <!-- Language Selection -->
  <div class="language-select">
    <!-- <app-language-select></app-language-select> -->
  </div>

  <div class="spacer" fxHide fxShow.xs></div>

  <!-- Quest Icon -->
  <div>
    <img src="assets/images/logos/quest-alliance.svg" />
  </div>

  <!-- Welcome -->
  <h1 class="core-main-title">{{ 'login.welcome' | translate }}</h1>

  <!-- Login -->
  <h2 class="core-sub-title underline">Login</h2>

  <!-- Login Card -->
  <div
    fxFlexAlign="stretch"
    fxFlexOffset="15px"
    fxLayout="row"
    fxLayoutAlign="center"
    *ngIf="isLoginWithOtp"
  >
    <mat-card fxFlex.gt-xs="570px" fxFlex.xs="95">
      <mat-card-content fxLayout="row" fxLayoutAlign="center">
        <form
          fxFlex.gt-md="60"
          fxFlex.md="70"
          fxFlex.sm="80"
          fxFlex.xs="90"
          fxLayout="column"
          fxLayoutAlign="center stretch"
          fxLayoutGap="5px"
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit()"
        >
          <!-- Email -->
          <div class="p-field">
            <span class="p-float-label required">
              <input type="text" pInputText formControlName="username" />
              <label>{{ 'login.email' | translate }}</label>
            </span>
            <app-validation-error
              [control]="loginForm.get(['username'])"
              [field]="'login.email' | translate"
            ></app-validation-error>
          </div>

          <!-- mobile no -->
          <div class="p-field" *ngIf="isCaptchaShown">
            <span class="p-float-label required">
              <input type="text" pInputText formControlName="mobile" />
              <label>{{ 'login.mobile' | translate }}</label>
            </span>
            <app-validation-error
              [control]="loginForm.get(['mobile'])"
              [field]="'login.mobile' | translate"
            ></app-validation-error>
          </div>

          <!-- Password -->
          <div class="p-field">
            <span class="p-float-label required">
              <p-password
                formControlName="password"
                appendTo="body"
                styleClass="p-password p-component p-inputwrapper p-input-icon-right"
                [toggleMask]="true"
                [feedback]="false"
              >
              </p-password>
              <label>{{ 'login.password' | translate }}</label>
            </span>
            <app-validation-error
              [control]="loginForm.get(['password'])"
              [field]="'login.password' | translate"
            ></app-validation-error>
          </div>

          <div class="row mt-3" *ngIf="isCaptchaShown">
            <div class="col-sm-12 login-div">
              <re-captcha
                #captchaRef
                id="recaptcha_response"
                class="custom-recaptcha"
                (resolved)="onCaptchaResolved($event)"
                required
              ></re-captcha>
              <div
                *ngIf="
                  loginForm.get('recaptcha_response')?.invalid &&
                  (loginForm.get('recaptcha_response')?.dirty ||
                    loginForm.get('recaptcha_response')?.touched)
                "
                class="invalid-feedback"
              >
                <div *ngIf="loginForm.get('recaptcha_response')?.errors?.required">
                  This field is required.
                </div>
              </div>
            </div>
          </div>

          <!-- Login Button -->
          <button
            mat-flat-button
            fxFlexAlign="center"
            color="primary"
            [disabled]="loginForm.invalid"
            *ngIf="!isLoading; else spinner"
          >
            {{ isCaptchaShown ? ('login.send_otp' | translate) : ('login.login' | translate) }}
          </button>
          <!-- Spinner -->
          <ng-template #spinner>
            <div class="spinner-div" fxLayoutAlign="center">
              <mat-spinner [diameter]="25" [strokeWidth]="3"></mat-spinner>
            </div>
          </ng-template>
          <!-- Forgot Password? -->
          <div class="forgot-password" fxLayoutAlign="center" (click)="onClickForgotPassword()">
            Forgot Password?
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>

  <div
    fxFlexAlign="stretch"
    fxFlexOffset="15px"
    fxLayout="row"
    fxLayoutAlign="center"
    *ngIf="isVerifyOtp && isCaptchaShown"
  >
    <mat-card fxFlex.gt-xs="570px" fxFlex.xs="95">
      <mat-card-content fxLayout="row" fxLayoutAlign="center">
        <!-- Verify OTP -->
        <form
          fxFlex.gt-md="60"
          fxFlex.md="70"
          fxFlex.sm="80"
          fxFlex.xs="90"
          fxLayout="column"
          fxLayoutAlign="center stretch"
          fxLayoutGap="5px"
          [formGroup]="loginForm"
        >
          <!-- Heading 1 -->
          <h2 fxLayoutAlign="center" fxLayout.md="center">
            {{ 'login.otp_verification' | translate }}
          </h2>

          <!-- Heading 2 -->
          <div fxFlexOffset="30px" fxLayoutAlign="center" fxLayoutAlign.md="center">
            <h3 class="enter-otp">
              {{
                'login.enter_otp'
                  | translate : { name: loginForm.get(['mobile'])?.value.slice(0, 4) }
              }}
            </h3>
          </div>

          <!-- OTP -->
          <div fxLayoutAlign="center" fxFlexOffset="30px">
            <div fxFlex="85px">
              <p-inputMask
                placeholder="X-X-X-X"
                formControlName="otp"
                mask="9-9-9-9"
                slotChar="X"
                [unmask]="true"
              ></p-inputMask>
              <app-validation-error
                [control]="loginForm.get(['otp'])"
                [field]="'login.otp' | translate"
              ></app-validation-error>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12 mb-3">
              <re-captcha
                #otpCaptchaRef
                id="recaptcha_response_otp"
                class="custom-recaptcha"
                (resolved)="onCaptchaResolvedOtp($event)"
                required
              ></re-captcha>
              <div
                *ngIf="
                  loginForm.get('recaptcha_response_otp')?.invalid &&
                  (loginForm.get('recaptcha_response_otp')?.dirty ||
                    loginForm.get('recaptcha_response_otp')?.touched)
                "
                class="invalid-feedback"
              >
                <div *ngIf="loginForm.get('recaptcha_response_otp')?.errors?.required">
                  This field is required.
                </div>
              </div>
            </div>
          </div>
        </form>
      </mat-card-content>
      <!-- Button Row -->
      <div fxLayout="row" fxLayoutAlign="space-around center">
        <!-- Resend OTP -->
        <button
          mat-flat-button
          color="accent"
          (click)="onClickResendOtp()"
          *ngIf="resendOtpTimeLeft === 0; else otpTimer"
        >
          {{ 'login.resend_otp' | translate }}
        </button>

        <!-- Otp Timer -->
        <ng-template #otpTimer>
          <span class="otp-timer">
            {{
              'login.resend_otp_in'
                | translate : { time: (resendOtpTimeLeft * 1000 | date : 'mm:ss' : 'UTC') }
            }}
          </span>
        </ng-template>

        <!-- Verify OTP -->
        <button
          mat-flat-button
          fxFlexAlign="center"
          color="primary"
          (click)="onClickVerifyOTP()"
          [disabled]="loginForm.invalid"
        >
          {{ 'login.login' | translate }}
        </button>
      </div>
    </mat-card>
  </div>
</div>
